import {FC} from "react";
import styles from './TagContainer.module.scss';
import * as React from "react";

const TagContainer: FC = ({ children }) => (
  <div className={styles.tagContainer}>{children}</div>
);

export default TagContainer;